import { UseFormReturn } from 'react-hook-form'

import { AssetInputSchema } from '../../logic/form'
import { FormFieldsForDialog } from '../../types'
import { TokenWithBalance } from '@/domain/common/types'
import { Form } from '@/ui/atoms/form/Form'
import { AssetInput, AssetInputRenderError } from '@/ui/organisms/asset-input/AssetInput'

export interface DialogFormProps {
  selectorAssets: TokenWithBalance[]
  assetsFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  showUsdValueWhenZero?: boolean
  renderError?: AssetInputRenderError
}

export function DialogForm({ selectorAssets, assetsFields, form, showUsdValueWhenZero, renderError }: DialogFormProps) {
  const { selectedAsset, changeAsset, maxSelectedFieldName, maxValue, onMaxSet } = assetsFields

  return (
    <Form {...form}>
      <AssetInput
        label="Amount"
        fieldName="value"
        control={form.control}
        selectorAssets={selectorAssets}
        selectedAsset={selectedAsset}
        setSelectedAsset={changeAsset}
        maxValue={maxValue}
        maxSelectedFieldName={maxSelectedFieldName}
        showError
        showUsdValueWhenZero={showUsdValueWhenZero}
        renderError={renderError}
        onMaxSet={onMaxSet}
      />
    </Form>
  )
}
